import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Grid } from '@material-ui/core'
import classnames from 'classnames'
import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { SanityHeroImageOptionDocument } from '../../../../../../../groq/sanity-dispensaries/types'
import { dispensaryImageUrlFor } from '../../../../../../../lib/sanity'
import { DispensaryHeroFormValues } from '../CustomizeHomePage'
import * as Styled from './styled'

export interface HeroImageSelectProps {
  disabled: boolean
  options: ReadonlyArray<SanityHeroImageOptionDocument>
  optionForSlug: SanityHeroImageOptionDocument | null
}

const HeroImageSelect: React.FC<HeroImageSelectProps> = ({ disabled, options, optionForSlug }) => {
  const { control, register, setValue } = useFormContext<DispensaryHeroFormValues>()
  const { selectedImageOptionId } = useWatch({ control })
  const handleSelectionChange = (ref: string) =>
    setValue('selectedImageOptionId', ref, { shouldDirty: true })

  return (
    <Styled.StyledGrid container spacing={5}>
      {options.map((option) => (
        <Grid key={option._id} item xs={6}>
          <Styled.Button
            disabled={disabled}
            onClick={() => handleSelectionChange(option._id)}
            className={classnames({ selected: selectedImageOptionId === option._id })}
          >
            <Styled.Image
              src={
                dispensaryImageUrlFor({ _ref: option.image.asset._ref })
                  .width(320)
                  .dpr(2)
                  .auto('format')
                  .url() || ''
              }
              className={classnames({ selected: selectedImageOptionId === option._id })}
            />
          </Styled.Button>
          <Styled.IconContainer
            className={classnames({ selected: selectedImageOptionId === option._id })}
          >
            <FontAwesomeIcon icon={faCheckCircle} />
          </Styled.IconContainer>
        </Grid>
      ))}
      <Grid item xs={6}>
        <Styled.Button
          disabled={disabled}
          onClick={() => handleSelectionChange(optionForSlug?._id || 'new')}
          className={classnames({
            selected: selectedImageOptionId === (optionForSlug?._id || 'new'),
          })}
        >
          Create Your Own
        </Styled.Button>
        <Styled.IconContainer
          className={classnames({
            selected: selectedImageOptionId === (optionForSlug?._id || 'new'),
          })}
        >
          <FontAwesomeIcon icon={faCheckCircle} />
        </Styled.IconContainer>
      </Grid>
      <input type="hidden" name="selectedImageOptionId" ref={register} />
    </Styled.StyledGrid>
  )
}

export default HeroImageSelect
